import { TCertificationSchema } from 'transfix-form/forms/CarrierCertifications/components/CertificationModal/schema/CertificationSchema'
import { IUpdateMotorCarrierCertificationInput, Maybe } from 'types/FMSGraphqlTypes'
import { IMotorCarrierCertificationsFragment } from '../graphql/MotorCarrierCertificationsFragment'

export const getUpdateMotorCarrierCertificationInput = ({
  formValues,
  motorCarrierId,
}: {
  formValues: TCertificationSchema
  motorCarrierId: IMotorCarrierCertificationsFragment['id']
}): Maybe<IUpdateMotorCarrierCertificationInput> => {
  const { code } = formValues || {}

  if (!code) {
    return null
  }

  return {
    ...formValues,
    motorCarrierId,
    code,
  }
}
